/* eslint-disable quotes */
import React from 'react';

import { Backdrop, Button } from '@/kaya';

import styles from './uploadMusicDonePopup.module.scss';

interface UploadMusicDonePopupProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const UploadMusicDonePopup = (props: UploadMusicDonePopupProps) => {
  const { visible, setVisible } = props;

  return (
    <div>
      <Backdrop visible={visible} setVisible={setVisible} />
      <div className={styles.uploadPopup}>
        <p className={styles.title}>Hey There!</p>
        <p className={styles.description}>
          {`Your music has reached to us with all necessary documents. It is under review, we will get back to you in 2-3 days.\nThank you.`}
        </p>
        <Button
          type="Primary"
          width="200px"
          onClick={() => {
            setVisible(false);
          }}
        >
          Done
        </Button>
      </div>
    </div>
  );
};

export default UploadMusicDonePopup;
